export const brand = {
  name: "Rythugaru",
  fullName: "Rythugaru Agri Tourism",
  tagline: "From Social Life to Soil Life",
  region: "Konaseema, Andhra Pradesh, India",
  email: "hello@rythugaru.com",
  phone: "+91 99595 35367",
  whatsapp: "919959535367",
};

export const navLinks = [
  { label: "Experiences", href: "/experiences" },
  { label: "Farms", href: "/farms" },
  { label: "Farmers", href: "/farmers" },
  { label: "Konaseema", href: "/konaseema" },
  { label: "Plan Trip", href: "/plan-your-trip" },
  { label: "Stories", href: "/stories" },
  { label: "Reviews", href: "/reviews" },
  { label: "Contact", href: "/contact" },
];

export const heroStats = [
  { value: "20+", label: "Farm Experiences" },
  { value: "8+", label: "Villages Connected" },
  { value: "100%", label: "Farmer First" },
  { value: "365", label: "Days of Rural Life" },
];

export const whyPoints = [
  "We all eat food every day. But how often do we experience where it comes from?",
  "Behind every grain of rice, every fruit, every vegetable, and every meal is a farmer, a family, a farm, and a story.",
  "Farmers shouldn't just produce food for society. Society should also experience and understand the life behind that food.",
];

export const journeyMoments = [
  { icon: "ri-sun-line", text: "Imagine waking up to the sound of birds." },
  { icon: "ri-plant-line", text: "Walking through a green field." },
  { icon: "ri-user-heart-line", text: "Meeting the farmer who grows your food." },
  { icon: "ri-hand-heart-line", text: "Getting your hands into the soil." },
  { icon: "ri-book-open-line", text: "Learning how crops are cultivated." },
  { icon: "ri-shopping-basket-line", text: "Picking fresh produce." },
  { icon: "ri-restaurant-2-line", text: "Sharing a traditional meal." },
  { icon: "ri-chat-quote-line", text: "Listening to stories from the village." },
];

export const agriTourismTags = [
  { emoji: "🌾", label: "Farming" },
  { emoji: "🌱", label: "Nature" },
  { emoji: "👨‍🌾", label: "Farmers" },
  { emoji: "🏡", label: "Village Life" },
  { emoji: "🍲", label: "Local Food" },
  { emoji: "🎨", label: "Rural Culture" },
  { emoji: "🐄", label: "Farm Activities" },
  { emoji: "🌿", label: "Traditional Knowledge" },
];

export const experiences = [
  {
    slug: "farmer-for-a-day",
    emoji: "🌾",
    title: "Farmer for a Day",
    tagline: "A day in the life of a farmer",
    description:
      "Walk through the fields, learn about crops, participate in seasonal farming activities, meet the farming family, and understand the work behind the food on your plate.",
    highlights: ["Farming", "Farm Walk", "Farmer Interaction", "Seasonal Activities", "Traditional Food"],
    perfectFor: "Families • Children • Groups",
  },
  {
    slug: "soil-to-plate",
    emoji: "🌱",
    title: "Soil to Plate",
    tagline: "The journey of food",
    description:
      "Learn about the soil, crops, cultivation, harvesting, and traditional food preparation. Depending on the season, you may even harvest ingredients and experience how they become part of a local meal.",
    highlights: ["Farm Visit", "Harvesting", "Cooking", "Farm-to-Table Meal"],
    perfectFor: "Food Lovers • Families",
  },
  {
    slug: "village-life-experience",
    emoji: "🏡",
    title: "Village Life Experience",
    tagline: "Discover the rhythm of the village",
    description:
      "Explore the village, meet local people, discover traditional practices, taste local food, and learn about the customs and stories that make every village unique.",
    highlights: ["Village Walk", "Local Culture", "Food", "Stories", "Traditional Activities"],
    perfectFor: "Travelers • Families",
  },
  {
    slug: "orchard-plantation-experiences",
    emoji: "🌴",
    title: "Orchard & Plantation Experiences",
    tagline: "Fruits & crops up close",
    description:
      "Walk through beautiful orchards and plantations and discover how your favorite fruits and crops are grown. Depending on the season, visitors can experience planting, harvesting, tasting, and learning directly from farmers.",
    highlights: ["Orchard Walk", "Plantation Tour", "Seasonal Harvest", "Farmer Stories"],
    perfectFor: "Nature Lovers • Groups",
  },
  {
    slug: "family-farm-experiences",
    emoji: "👨‍👩‍👧",
    title: "Family Farm Experiences",
    tagline: "Learning beyond the classroom",
    description:
      "Let children touch the soil, see crops growing, meet farmers, learn about animals, and understand where their food comes from. A perfect weekend experience for families looking to reconnect with nature and each other.",
    highlights: ["Soil Play", "Farm Animals", "Crop Discovery", "Family Time"],
    perfectFor: "Families • Children",
  },
  {
    slug: "school-educational-farm-visits",
    emoji: "🏫",
    title: "School & Educational Farm Visits",
    tagline: "From textbook to real world",
    description:
      "Our educational farm visits introduce students to soil and farming, crop cultivation, irrigation, sustainable agriculture, food production, rural livelihoods, farm animals, and traditional farming practices.",
    highlights: ["Soil & Farming", "Irrigation", "Sustainable Agriculture", "Farm Animals"],
    perfectFor: "Schools • Students",
  },
  {
    slug: "corporate-rural-experiences",
    emoji: "🏢",
    title: "Corporate Rural Experiences",
    tagline: "Beyond the office",
    description:
      "Rythugaru creates meaningful rural experiences for corporate teams that combine nature, agriculture, local food, community interaction, and team activities.",
    highlights: ["Team Outings", "Employee Engagement", "Rural Immersion", "CSR Programs"],
    perfectFor: "Corporates • Teams",
  },
  {
    slug: "rural-culture-traditions",
    emoji: "🎨",
    title: "Rural Culture & Traditions",
    tagline: "Customs, crafts & festivals",
    description:
      "Immerse yourself in the festivals, crafts, music, and everyday traditions of rural India. Learn from artisans and elders who keep these practices alive across generations.",
    highlights: ["Festivals", "Handicrafts", "Folk Culture", "Community Stories"],
    perfectFor: "Culture Seekers • Travelers",
  },
];

export const discoverFarmPoints = [
  "Every farm has a story.",
  "Every farmer has a journey.",
  "Every crop has a season.",
];

export const discoverSteps = ["Farms", "Farmers", "Experiences", "Stories"];

export const farmerBenefits = [
  { icon: "ri-layout-grid-line", label: "Farm listing" },
  { icon: "ri-lightbulb-line", label: "Experience creation" },
  { icon: "ri-calendar-check-line", label: "Visitor bookings" },
  { icon: "ri-megaphone-line", label: "Digital promotion" },
  { icon: "ri-chat-smile-2-line", label: "Customer communication" },
  { icon: "ri-secure-payment-line", label: "Payments" },
  { icon: "ri-star-line", label: "Reviews" },
  { icon: "ri-settings-3-line", label: "Experience management" },
];

export const howItWorks = [
  {
    step: "01",
    title: "Discover",
    text: "Explore farms and experiences available through Rythugaru.",
    icon: "ri-compass-3-line",
  },
  {
    step: "02",
    title: "Choose",
    text: "Select an experience based on your interests, location, season, and group.",
    icon: "ri-focus-3-line",
  },
  {
    step: "03",
    title: "Book",
    text: "Choose your preferred date and complete your booking.",
    icon: "ri-calendar-2-line",
  },
  {
    step: "04",
    title: "Experience",
    text: "Meet the farmer. Explore the farm. Participate. Learn. Taste. Enjoy.",
    icon: "ri-seedling-line",
  },
  {
    step: "05",
    title: "Connect",
    text: "Share your experience, leave a review, and stay connected with the farm.",
    icon: "ri-heart-3-line",
  },
];

export const audiences = [
  { title: "For Children", text: "Learn where food comes from.", icon: "ri-seedling-line" },
  { title: "For Families", text: "Spend meaningful time together in nature.", icon: "ri-home-heart-line" },
  { title: "For Students", text: "Experience agriculture beyond the classroom.", icon: "ri-graduation-cap-line" },
  { title: "For Professionals", text: "Take a break from the city and reconnect with nature.", icon: "ri-briefcase-line" },
  { title: "For Corporates", text: "Build connections through shared rural experiences.", icon: "ri-team-line" },
  { title: "For Travelers", text: "Discover the real stories of rural India.", icon: "ri-road-map-line" },
];

export const farmToPlateSteps = [
  "Soil",
  "Seed",
  "Crop",
  "Farmer",
  "Harvest",
  "Kitchen",
  "Plate",
];

export const storyLines = [
  "They are found in fields.",
  "In the hands of farmers.",
  "In generations of farming knowledge.",
  "In early mornings.",
  "In changing seasons.",
  "In rain-fed fields and irrigation canals.",
  "In the hope of every harvest.",
];

export const sustainabilityPoints = [
  "Supports local farmers",
  "Promotes local food",
  "Celebrates rural knowledge",
  "Creates supplementary rural income opportunities",
  "Encourages responsible visitor behavior",
  "Preserves local traditions",
  "Builds awareness about agriculture",
];

export const whyRythugaru = [
  {
    emoji: "👨‍🌾",
    title: "Farmer First",
    text: "We put farmers and their stories at the heart of every experience.",
  },
  {
    emoji: "🌱",
    title: "Authentic Experiences",
    text: "Real farms. Real people. Real stories.",
  },
  {
    emoji: "🍲",
    title: "Local & Seasonal",
    text: "Experience food and activities based on the season and the place.",
  },
  {
    emoji: "🏡",
    title: "Community Connection",
    text: "Go beyond sightseeing and connect with rural communities.",
  },
  {
    emoji: "📚",
    title: "Learn Through Experience",
    text: "Turn agriculture, nature, culture, and food into memorable learning experiences.",
  },
  {
    emoji: "❤️",
    title: "Meaningful Travel",
    text: "Travel not just to see a place—but to understand it.",
  },
];

export const konaseemaHighlights = [
  { icon: "ri-plant-line", label: "Lush green landscapes" },
  { icon: "ri-leaf-line", label: "Coconut groves" },
  { icon: "ri-water-flash-line", label: "Waterways & canals" },
  { icon: "ri-home-4-line", label: "Villages & traditions" },
];

export const joinPaths = [
  {
    icon: "ri-walk-line",
    label: "For Visitors",
    title: "Discover farms. Meet farmers. Experience rural life.",
    cta: "Explore Experiences",
    href: "/#experiences",
    theme: "primary",
  },
  {
    icon: "ri-plant-line",
    label: "For Farmers",
    title: "Showcase your farm. Share your story. Welcome visitors.",
    cta: "Become a Farm Partner",
    href: "/farm-partner",
    theme: "accent",
  },
  {
    icon: "ri-graduation-cap-line",
    label: "For Schools",
    title: "Turn agriculture into an unforgettable learning experience.",
    cta: "Plan a School Visit",
    href: "/experiences/school-educational-farm-visits",
    theme: "secondary",
  },
  {
    icon: "ri-briefcase-line",
    label: "For Corporates",
    title: "Create meaningful experiences beyond the workplace.",
    cta: "Plan a Corporate Experience",
    href: "/experiences/corporate-rural-experiences",
    theme: "foreground",
  },
];

export const footerLinks = [
  {
    heading: "Explore",
    links: [
      { label: "Experiences", href: "/experiences" },
      { label: "Discover Farms", href: "/farms" },
      { label: "Meet Our Farmers", href: "/farmers" },
      { label: "Konaseema", href: "/konaseema" },
      { label: "Plan Your Trip", href: "/plan-your-trip" },
    ],
  },
  {
    heading: "Partner",
    links: [
      { label: "For Farmers", href: "/farm-partner" },
      { label: "Become a Farm Partner", href: "/farm-partner" },
      { label: "School Visits", href: "/experiences/school-educational-farm-visits" },
      { label: "Corporate Experiences", href: "/experiences/corporate-rural-experiences" },
    ],
  },
  {
    heading: "Learn",
    links: [
      { label: "How It Works", href: "/#how-it-works" },
      { label: "Farm to Plate", href: "/#farm-to-plate" },
      { label: "Stories From the Soil", href: "/stories" },
      { label: "Visitor Reviews", href: "/reviews" },
      { label: "Contact Us", href: "/contact" },
    ],
  },
];

export const legalLinks = [
  { label: "Terms & Conditions", href: "/terms" },
  { label: "Privacy Policy", href: "/privacy" },
];

export const socialLinks = [
  { icon: "ri-instagram-line", href: "#", label: "Instagram" },
  { icon: "ri-facebook-circle-line", href: "#", label: "Facebook" },
  { icon: "ri-youtube-line", href: "#", label: "YouTube" },
  { icon: "ri-whatsapp-line", href: "#", label: "WhatsApp" },
];